.wrapper {
  background-color: #f0f3f5;
  margin-top: var(--space-6);
}

.paragraph {
  font-size: 12px;
  line-height: 12px;
  color: #636e72;
  font-weight: 600;
  margin-bottom: 0;
}